// Estilos comunes
export const STYLES = {
    CONTAINER: {
        backgroundColor: "#F7F7F7",
        minHeight: "100vh",
        color: "#555555",
        fontSize: "13px",
    },
    CONTENT: {
        backgroundColor: "#fff",
        borderRadius: "5px",
        padding: "20px 64px",
        marginTop: "0",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
        position: "relative",
    },
    TAG: {
        color: "#c3f7fa",
        textColor: "#555555",
    },
}

// Roles disponibles
export const ROLES = [
    { key: "admin", value: "admin", label: "Administrador" },
    { key: "pharmacy", value: "pharmacy", label: "Farmacia" },
]

// Mensajes de error
export const ERROR_MESSAGES = {
    REQUIRED_EMAIL: "Por favor ingresa un correo electrónico válido",
    REQUIRED_NAME: "Por favor ingresa el nombre de usuario",
    REQUIRED_LASTNAME: "Por favor ingresa el apellido",
    REQUIRED_PASSWORD: "La contraseña es obligatoria",
    MIN_PASSWORD: "Debe tener al menos 8 caracteres",
    REQUIRED_ROLE: "Por favor selecciona al menos un rol",
    REQUIRED_PHARMACY: "Por favor selecciona al menos una sucursal",
    FETCH_USERS: "Error al obtener usuarios",
    UPDATE_USER: "Error al actualizar el usuario",
    CREATE_USER: "Error al crear el usuario",
}

// Mensajes de éxito
export const SUCCESS_MESSAGES = {
    UPDATE_USER: "Usuario actualizado correctamente",
    CREATE_USER: "Usuario creado correctamente",
}

